import React, { useMemo } from 'react';

import { Box } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import { useUIContext } from 'state/ui';

import { Price, PriceAndCaloriesText } from './styled';
import { PriceAndCaloriesProps } from './types';

export const PriceAndCalories: React.FC<React.PropsWithChildren<PriceAndCaloriesProps>> = ({
  price,
  showPriceUpcharge = true,
  calories,
}) => {
  const { formatCurrencyForLocale } = useUIContext();

  const isCaloricRange = calories && calories.includes('-');

  const formattedPrice = useMemo(() => {
    if (!price) {
      return null;
    }
    const basePrice = formatCurrencyForLocale(price);
    const sign = price < 0 ? '' : showPriceUpcharge ? '+' : '';

    return `${sign}${basePrice}`;
  }, [formatCurrencyForLocale, price, showPriceUpcharge]);

  if (!price && !calories) {
    return null;
  }

  return (
    <>
      {isCaloricRange ? (
        <Box flexDirection="column" alignItems={'center'}>
          {formattedPrice && <Price>{formattedPrice}</Price>}
          <PriceAndCaloriesText>{calories}</PriceAndCaloriesText>
        </Box>
      ) : (
        <PriceAndCaloriesText>
          {formattedPrice && <Price>{formattedPrice}</Price>}
          {formattedPrice && calories && <Typography>{' | '}</Typography>}
          <Typography>{calories}</Typography>
        </PriceAndCaloriesText>
      )}
    </>
  );
};
